import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.141 4.996a8 8 0 0 1 9.543 1.372L20.528 9H17a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1V4a1 1 0 1 0-2 0v3.637l-2.934-2.715a10 10 0 1 0 2.367 10.411 1 1 0 1 0-1.886-.666 8 8 0 1 1-11.406-9.67",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }